(() => {
    "use strict";

    const COMPRESS = "site-header--compress";
    const GAP = 40; // the only tuning constant: min gap menu↔icons, px
    const RESIZE_DEBOUNCE = 150;

    let header = null;
    let minWidth = 0;
    let lock = false;
    let observer = null;
    let timer = 0;
    let bound = false;

    const measure = () => {
        const clone = header.cloneNode(true);
        clone.classList.remove(COMPRESS);
        // .js__header__clone drops the mobile-only display:none
        // from .nav--default
        clone.classList.add("js__header__clone");
        clone.style.cssText = [
            "position:fixed!important",
            "top:-9999px!important",
            "left:0!important",
            "width:3000px!important",
            "max-width:none!important",
            "visibility:hidden!important"
        ].join(";");
        document.body.appendChild(clone);

        const nav = clone.querySelector("[data-nav]");
        const items = nav?.querySelector(".menu__items");
        const icons = nav?.querySelector(".menu__item--icons");
        const logo = clone.querySelector(".logo");
        let min = 0;

        if (nav && items && icons) {
            const box = clone.getBoundingClientRect();
            const padLeft =
                parseFloat(getComputedStyle(nav).paddingLeft) || 0;
            const logoRight = logo
                ? logo.getBoundingClientRect().right - box.left
                : 0;
            // left zone: the nav's reserved padding or the real logo width,
            // whichever is larger
            const left = Math.max(padLeft, logoRight);
            // right zone: the icons plus their offset from the right edge
            const right = box.right - icons.getBoundingClientRect().left;
            const menu = items.getBoundingClientRect().width;
            min = Math.ceil(left + menu + GAP + right);
        }

        clone.remove();
        return min;
    };

    const apply = () => {
        if (!minWidth) return;
        // clientWidth excludes the scrollbar, unlike window.innerWidth
        const want = document.documentElement.clientWidth < minWidth;
        if (header.classList.contains(COMPRESS) === want) return;
        lock = true;
        header.classList.toggle(COMPRESS, want);
        lock = false;
    };

    const recalc = () => {
        if (!header) return;
        minWidth = measure();
        apply();
    };

    const onResize = () => {
        clearTimeout(timer);
        timer = setTimeout(recalc, RESIZE_DEBOUNCE);
    };

    const bindGlobals = () => {
        if (bound) return;
        bound = true;
        document.addEventListener("theme:resize", recalc);
        window.addEventListener("resize", onResize);
        window.addEventListener("orientationchange", recalc);
        document.fonts?.ready.then(recalc);
    };

    const init = () => {
        header = document.querySelector(".site-header[data-site-header]");
        if (!header) return;

        recalc();

        // Independent of listener order: if the theme sets its own class on
        // top of ours, correct it back.
        observer?.disconnect();
        observer = new MutationObserver(() => {
            if (!lock) apply();
        });
        observer.observe(header, {
            attributes: true,
            attributeFilter: ["class"]
        });

        bindGlobals();
    };

    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", init);
    } else {
        init();
    }

    document.addEventListener("shopify:section:load", (event) => {
        if (event.target?.querySelector("[data-site-header]")) init();
    });
})();
